import { render, staticRenderFns } from "./ProtocolTaxes.vue?vue&type=template&id=9c23dfe2&scoped=true"
import script from "./ProtocolTaxes.vue?vue&type=script&lang=js"
export * from "./ProtocolTaxes.vue?vue&type=script&lang=js"
import style0 from "./ProtocolTaxes.vue?vue&type=style&index=0&id=9c23dfe2&prod&lang=stylus&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c23dfe2",
  null
  
)

export default component.exports